
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.417 7A5.417 5.417 0 111.583 7a5.417 5.417 0 0110.834 0zM.333 7a6.667 6.667 0 1013.333 0A6.667 6.667 0 00.333 7zm6.042-3.542V7c0 .208.104.404.279.521l2.5 1.667a.623.623 0 00.867-.175.623.623 0 00-.175-.867l-2.221-1.48V3.459A.623.623 0 007 2.833a.623.623 0 00-.625.625z","fill":"#9DA7B2"}})])
          )
        }
      }
    